var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "订单发货",
        visible: _vm.dialogVisible,
        width: "500px",
        "append-to-body": "",
        fullscreen: _vm.device === "mobile",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
        close: _vm.dialogClose,
      },
      scopedSlots: _vm._u([
        {
          key: "footer",
          fn: function () {
            return [
              _c("el-button", { on: { click: _vm.handleCancel } }, [
                _vm._v("取　消"),
              ]),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.handleSubmit } },
                [_vm._v("确定提交")]
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _vm.order
        ? _c(
            "el-form",
            {
              ref: "deliveryForm",
              attrs: {
                model: _vm.shipmentInfo,
                rules: _vm.rules,
                "label-width": "100px",
              },
            },
            [
              _c("el-form-item", { attrs: { label: "订单编号" } }, [
                _vm._v(_vm._s(_vm.order.orderNumber)),
              ]),
              _c("el-form-item", { attrs: { label: "支付单号" } }, [
                _vm._v(_vm._s(_vm.order.payNumber)),
              ]),
              _c(
                "el-form-item",
                { attrs: { label: "快递公司", prop: "logisticsCode" } },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "max-width",
                      attrs: {
                        filterable: "",
                        clearable: "",
                        placeholder: "请选择快递公司",
                      },
                      model: {
                        value: _vm.shipmentInfo.logisticsCode,
                        callback: function ($$v) {
                          _vm.$set(_vm.shipmentInfo, "logisticsCode", $$v)
                        },
                        expression: "shipmentInfo.logisticsCode",
                      },
                    },
                    _vm._l(_vm.deliveries, function (item, index) {
                      return _c(
                        "el-option",
                        {
                          key: index,
                          attrs: {
                            label: item.deliveryName,
                            value: item.deliveryId,
                          },
                        },
                        [
                          _c("span", [_vm._v(_vm._s(item.deliveryName))]),
                          _c("span", [_vm._v(_vm._s(item.deliveryId))]),
                        ]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "快递单号", prop: "logisticsNumber" } },
                [
                  _c("el-input", {
                    staticClass: "max-width",
                    attrs: { placeholder: "请输入快递单号", clearable: "" },
                    model: {
                      value: _vm.shipmentInfo.logisticsNumber,
                      callback: function ($$v) {
                        _vm.$set(_vm.shipmentInfo, "logisticsNumber", $$v)
                      },
                      expression: "shipmentInfo.logisticsNumber",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }